import firebase from '@/firebase';

const state = {
    resourcesFetched: false,
    resources: []
}

const getters = {
    isResourcesFetched: state => state.resourcesFetched,
    getResources: state => state.resources
}

const mutations = {
    switchResourcesFetched: state => state.resourcesFetched = !state.isResourcesFetched,
    setResources: (state, payload) => state.resources = payload,
    clearResources: state => {
        state.isResourcesFetched = false;
        state.getResources = [];
    }
}

const actions = {
    fetchResources: async ({ commit, rootState: { auth: { userDetails: { grade } } } }) => {
        const resources = await firebase
            .firestore()
            .collection('resources')
            .where('availableFor', 'array-contains', grade)
            .get()
        const tempArr = []
        resources.forEach(r => tempArr.push(r.data()))
        commit('setResources', tempArr);
        commit('switchResourcesFetched');
    }
}

export default {
    state, getters, mutations, actions
}